import Navbar from './Navbar';

const Layout = ({ children }) => (
  <div className="flex min-h-screen flex-col bg-bg pt-16 text-fg">
    <Navbar />
    <main className="w-full grow">
      <div className="mx-auto w-full max-w-[1400px] px-3 md:px-6">{children}</div>
    </main>
  </div>
);

export default Layout;
